module.exports = __webpack_public_path__ + "static/media/vf_wpants_core.f0324b2a.svg";